import { AuthController } from '@controllers/auth-controller';
import { ONBOARDING_HELP_AND_SUPPORT } from '@utils/controller-utils';
import { codeSplit } from 'bernie-core';

export class OnboardHelpAndSupportController extends AuthController {
  public pageId = ONBOARDING_HELP_AND_SUPPORT;
  public path = '/onboarding/help';
  public routeName = 'OnboardingHelpAndSupport';
  public bundles = [];
  public pageTitle = 'controllers.onboardingHelpAndSupport';
  public component = codeSplit(
    () => import(/* webpackChunkName: "OnboardingHelpAndSupport" */ '@views/onboarding-help-and-support'),
  );
  public exact = true;
  public isPartnerView = true;
  public isAdminView = true;
  public accessRoles = [];
}
